export default __webpack_public_path__ + "static/media/logo-whatsapp.e5dc3036.png";